'use strict';

angular
  .module('adminDefaultEntitlementControllers')

  .controller('MainDefaultEntitlementController', [
    '$scope',
    '$translate',
    'topBar',
    'searchService',
    'authenticatedUser',
    function ($scope, $translate, topBar, searchService, authenticatedUser) {
      $translate('iam.admin.defaultEntitlement.pageTitle').then(function (translation) {
        topBar.setTitle(
          '<i class="fa fa-key"></i><i class="fa fa-long-arrow-right" style="font-size: 20px;vertical-align: top;"></i><i class="fa fa-sitemap"></i>&nbsp;&nbsp;<span>' +
            translation +
            '</span>'
        );
      });

      $scope.currentUserIdentity = authenticatedUser.IdentityName;

      $scope.$watch('keywordsSearch', function (newKeywords, oldKeywords) {
        if (newKeywords !== oldKeywords) {
          if (_.isEmpty(newKeywords)) $scope.clearSearch();
          else $scope.searchSystems();
        }
      });

      $scope.searchSystems = function () {
        searchService.searchUnstructuredSystems($scope.keywordsSearch).then(function (hits) {
          $scope.systems = hits;
          $scope.selectedSystem = null;
        });
      };

      $scope.clearSearch = function () {
        $scope.keywordsSearch = null;
        $scope.systems = [];
        $scope.selectedSystem = null;

        $scope.infos = {};
        $scope.infos.displaySearch = true;
      };

      $scope.clearSearch();
    },
  ]);
